export const tableHeaders = [
  "Nombre",
  "Teléfono",
  "Email",
  "Doc. identidad",
  "Asesor",
  "Estado",
  "Fecha de creación",
  "Acciones",
];
